/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-12-18 14:00:42
 */
import React from 'react'

import styles from './index.module.scss'
import { InfoCircleOutlined } from '@ant-design/icons'

export default ({ imgs, successNum }) => {
  return (
    <>
      <div className={styles.multiImageContainer}>
        <div className={styles.gallery}>
          {imgs.map((url, index) => (
            <div key={index} className={styles.item}>
              <img src={url} className={styles.preview} alt="" />
            </div>
          ))}
        </div>
        <div className={styles.mask}></div>
      </div>
      <div
        className={styles.tip}
        style={{
          marginLeft: 20
        }}
      >
        <InfoCircleOutlined style={{ fontSize: 12, marginRight: 2 }} />
        {successNum > 8 ? '当前只展示部分照片，' : ''}
        下载后不含“今日水印相机”水印
      </div>
    </>
  )
}
